export default "__VITE_ASSET__3a5d904c__"